import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpUtils} from "../shared/http.utils";
import {ApplicationNotificationFilters} from "../model/filters/application-notification.filters";
import {ApplicationNotificationPersistRequest} from "../model/requests/application-notification-persist-request";

@Injectable({
  providedIn: 'root'
})

export class ApplicationNotificationsServiceService {
  private readonly notificationsURL: string;

  constructor(private http: HttpClient) {
    this.notificationsURL = "/catalog/application_notifications";
  }

  public getNotifications(offset?: number, limit?: number, filters?: ApplicationNotificationFilters): Observable<any>{
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams(offset, limit));
    let body = (filters != null) ? filters : new ApplicationNotificationFilters();
    return this.http.post<any>(this.notificationsURL, body, options);
  }

  public createApplicationNotification(notificationCreationData: ApplicationNotificationPersistRequest) {
    let url = `${this.notificationsURL}/create`;
    return this.http.post<any>(url, notificationCreationData);
  }

  public editApplicationNotification(notificationCreationData: ApplicationNotificationPersistRequest) {

    let url = `${this.notificationsURL}/edit`;
    return this.http.post<any>(url, notificationCreationData);
  }

  public deleteApplicationNotifications(identifiers: {tenantUuid: string, uuid: string}[]) {
    let url = `${this.notificationsURL}/delete`;
    return this.http.post<any>(url, identifiers, {observe: 'response'});
  }

}
